// Barra lateral de navegacion. En movil funciona como drawer superpuesto
// para evitar que el contenido principal quede comprimido.
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { FolderOpen, Buildings, Users, ClipboardText, Binoculars } from "@phosphor-icons/react";
import { X } from "lucide-react";
import UsersPanel from "./UsersPanel";
import FormsPanel from "./FormsPanel";
import InspectionsPanel from "./InspectionsPanel";

function StaticChip({ Icon, bg, color, isActive }) {
  return (
    <span style={{
      width: 30,
      height: 30,
      background: isActive ? bg : "rgba(255,255,255,0.07)",
      borderRadius: 8,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      transition: "background 0.2s",
    }}>
      <Icon size={16} weight="duotone" color={isActive ? color : "rgba(255,255,255,0.45)"} />
    </span>
  );
}

export default function Sidebar({ company, isTemplates, onGoTemplates, mobileOpen = false, onCloseMobile }) {
  const { canManageUsers, isAdmin, isAuxiliar } = useAuth();
  const [showUsers, setShowUsers] = useState(false);
  const [showForms, setShowForms] = useState(false);
  const [showInspections, setShowInspections] = useState(false);

  const showTemplatesLink = (isAdmin || isAuxiliar) && !isTemplates && !company;

  const handleTemplates = () => {
    onGoTemplates?.();
    onCloseMobile?.();
  };

  const handleUsers = () => {
    setShowUsers(true);
    onCloseMobile?.();
  };

  const handleForms = () => {
    setShowForms(true);
    onCloseMobile?.();
  };

  const handleInspections = () => {
    setShowInspections(true);
    onCloseMobile?.();
  };

  return (
    <>
      <div className={`sidebar-backdrop ${mobileOpen ? "visible" : ""}`} onClick={onCloseMobile} />
      <aside className={`sidebar ${mobileOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-brand">
          <div className="sidebar-brand-main">
            <img src="/logotipo.jpg" alt="RIESST-GO" className="brand-logo" />
            <div>
              <span className="brand-name">RIESST-GO</span>
              <span className="brand-sub">Gestion Documental SST</span>
            </div>
          </div>
          <button className="btn-icon sidebar-close" onClick={onCloseMobile} title="Cerrar menu">
            <X size={18} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <p className="nav-label">Navegacion</p>
          <div className={`nav-item ${!company && !isTemplates ? "active" : ""}`}>
            <StaticChip Icon={Buildings} bg="rgba(0,168,150,0.28)" color="#00C4AE" isActive={!company && !isTemplates} />
            <span className="nav-text">{company ? company.name : isTemplates ? "Documentos Originales" : "Empresas"}</span>
          </div>
        </nav>

        {showTemplatesLink && (
          <div style={{ padding: "0 8px" }}>
            <p className="nav-label" style={{ padding: "8px 8px 4px" }}>Biblioteca</p>
            <button className="nav-item" onClick={handleTemplates}>
              <StaticChip Icon={FolderOpen} bg="rgba(234,179,8,0.28)" color="#FDE047" isActive={false} />
              <span className="nav-text">Docs. Originales</span>
            </button>
          </div>
        )}

        {canManageUsers && (
          <div style={{ padding: "0 8px" }}>
            <button className="nav-item" onClick={handleUsers}>
              <StaticChip Icon={Users} bg="rgba(59,130,246,0.28)" color="#93C5FD" isActive={false} />
              <span className="nav-text">Usuarios</span>
            </button>
          </div>
        )}

        {isAdmin && (
          <div style={{ padding: "0 8px" }}>
            <button className="nav-item" onClick={handleForms}>
              <StaticChip Icon={ClipboardText} bg="rgba(219,39,119,0.28)" color="#F9A8D4" isActive={false} />
              <span className="nav-text">Formularios</span>
            </button>
          </div>
        )}

        {(isAdmin || isAuxiliar) && (
          <div style={{ padding: "0 8px" }}>
            <button className="nav-item" onClick={handleInspections}>
              <StaticChip Icon={Binoculars} bg="rgba(180,83,9,0.28)" color="#FCD34D" isActive={false} />
              <span className="nav-text">Inspecciones</span>
            </button>
          </div>
        )}

        <div className="sidebar-footer">
          <p>Sistema de Gestion SST</p>
          <p>v1.0.0</p>
        </div>

        <AnimatePresence>
          {showUsers && <UsersPanel key="users" onClose={() => setShowUsers(false)} />}
          {showForms && <FormsPanel key="forms" onClose={() => setShowForms(false)} />}
          {showInspections && <InspectionsPanel key="inspections" onClose={() => setShowInspections(false)} />}
        </AnimatePresence>
      </aside>
    </>
  );
}
